import React from "react"
import { useLocalSearchParams } from "expo-router"
import { useQuery } from "@tanstack/react-query"
import { BFScreen } from "@/components/standard/screen/BFScreen"
import { RequestsScreen } from "@/screens/loans/components/dashboard/requests"
import { Body } from "@/components/standard/BFText"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { BFScreenHeader } from "@/components/standard/screen/BFScreenHeader"

export default function LoanRequestsRoute() {
  const { loanId } = useLocalSearchParams<{ loanId: string }>()

  if (!loanId) {
    return null
  }

  return <LoanRequestsScreenWrapper loanId={loanId} />
}

interface LoanRequestsScreenWrapperProps {
  loanId: string
}

const LoanRequestsScreenWrapper: React.FC<LoanRequestsScreenWrapperProps> = ({
  loanId,
}) => {
  const {
    data: loanApplication,
    isLoading,
    error,
  } = useQuery(loanDashboardQueryOptions(loanId))

  if (isLoading) {
    return (
      <BFScreen>
        <BFScreenHeader title={"Requests"} />
        <Body className="text-center mt-8" color="hint">
          Loading requests...
        </Body>
      </BFScreen>
    )
  }

  if (error || !loanApplication) {
    return (
      <BFScreen>
        <BFScreenHeader title={"Requests"} />
        <Body className="text-center mt-8" color="error">
          Unable to load requests. Please try again.
        </Body>
      </BFScreen>
    )
  }

  // Get milestones from the loan application
  // The BfLoanApplicationType includes milestones field
  const milestones = loanApplication?.milestones || []

  return (
    <BFScreen>
      <BFScreenHeader title={"Processing Requests"} />
      <RequestsScreen
        milestones={milestones}
        hubspotLoanId={loanApplication.externalLoanId || undefined}
        portalUrl={loanApplication?.uploadPortalLink || undefined}
      />
    </BFScreen>
  )
}
